import React from 'react';
import ReactOnRails from 'react-on-rails';
import { Provider } from 'react-redux';

import WarrantyTransferForm from './WarrantyTransferForm';

export default props => {
  const warrantyTransferStore = ReactOnRails.getStore('warrantyTransferStore');

  return (
    <Provider store={warrantyTransferStore}>
      <WarrantyTransferForm {...props} />
    </Provider>
  );
};
